import { Wallet, Hourglass, MessageSquare } from "lucide-react";
import { fmtInr } from "@/lib/api";

export const LowCoinsBanner = ({ coins = 0, threshold = 60, onWallet, pendingRecharge, onOpenSupport }) => {
  if (pendingRecharge) {
    return (
      <div data-testid="recharge-pending-banner" className="rounded-2xl border border-sky-300 bg-sky-50 px-4 py-3 flex flex-wrap items-center gap-3 fade-up">
        <span className="w-9 h-9 rounded-xl bg-sky-100 text-sky-600 inline-flex items-center justify-center shrink-0 animate-pulse"><Hourglass size={18} /></span>
        <div className="flex-1 min-w-[160px]">
          <p className="text-sm font-bold text-sky-800">റീചാർജ് അഭ്യർത്ഥന സമർപ്പിച്ചു — ₹{pendingRecharge.amount_inr}{pendingRecharge.label ? ` · ${pendingRecharge.label}` : ""}</p>
          {pendingRecharge.screenshot
            ? <p data-testid="pending-recharge-note" className="text-[11px] font-bold text-emerald-700">✅ പേമെന്റ് പ്രൂഫ് ലഭിച്ചു — പരിശോധനയിൽ; 5 മിനിറ്റിനുള്ളിൽ ബാലൻസിൽ ക്രെഡിറ്റ് ആകും</p>
            : <p data-testid="pending-recharge-note" className="text-[11px] text-sky-700">⏳ അഡ്മിൻ ചാറ്റിൽ പേമെന്റ് വിവരങ്ങൾ (UPI / QR / ബാങ്ക്) അയച്ചു തരും — പേമെന്റ് കഴിഞ്ഞാൽ 5 മിനിറ്റിനുള്ളിൽ ബാലൻസിൽ ക്രെഡിറ്റ് ആകും ✓</p>}
        </div>
        {onOpenSupport && <button type="button" data-testid="pending-open-chat-button" onClick={onOpenSupport} className="rounded-full h-9 px-4 text-xs font-bold inline-flex items-center gap-1.5 bg-[var(--accent-c)] text-white hover:brightness-110"><MessageSquare size={13} /> അഡ്മിൻ ചാറ്റ്</button>}
      </div>
    );
  }
  if (coins >= threshold) return null;
  return (
    <div data-testid="low-coins-banner" className="rounded-2xl border border-amber-300 bg-amber-50 px-4 py-3 flex flex-wrap items-center gap-3 fade-up">
      <span className="w-9 h-9 rounded-xl bg-amber-100 text-amber-600 inline-flex items-center justify-center shrink-0"><Wallet size={18} /></span>
      <div className="flex-1 min-w-[160px]">
        <p className="text-sm font-bold text-amber-800">ബാലൻസ് തീരാനടുക്കുന്നു — <span className="font-num">{fmtInr(coins)}</span> മാത്രം</p>
        <p className="text-[11px] text-amber-700">ബാലൻസ് ₹{Math.max(1, Math.round(threshold / 6))}-ൽ താഴെയാണ്. പൂജ്യമാകുന്നതിന് മുമ്പ് റീചാർജ് ചെയ്യുക.</p>
      </div>
      <div className="flex items-center gap-2">
        <button type="button" data-testid="low-coins-wallet-button" onClick={onWallet} className="recharge-btn h-9 px-4 rounded-full text-xs font-bold inline-flex items-center gap-1.5"><Wallet size={13} /> റീചാർജ് ചെയ്യുക</button>
      </div>
    </div>
  );
};
